/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Microsoft_Tenant_DescriptionInputs */



/**
* | output |
* | --- |
* | "Only accept Microsoft accounts from your organization's own Microsoft Entra tenant. Without this, Microsoft sign-in recognizes members by their account addre..." |
*
* @param {Microsoft_Tenant_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const microsoft_tenant_description = /** @type {((inputs?: Microsoft_Tenant_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Microsoft_Tenant_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Microsoft-Konten aus dem eigenen Microsoft-Entra-Mandanten Ihrer Organisation zulassen. Ohne diese Einstellung erkennt die Microsoft-Anmeldung Mitglieder allein an der Kontoadresse – unabhängig davon, welcher Mandant sie bestätigt.")
	return /** @type {LocalizedString} */ ("Only accept Microsoft accounts from your organization's own Microsoft Entra tenant. Without this, Microsoft sign-in recognizes members by their account address alone, whichever tenant vouches for it.")
});